module.exports = __webpack_public_path__ + "media/images/crm/content-illustration-5-5b9f9e3b4a723582a91237745f45ec55.png";